module.exports = __webpack_public_path__ + "static/img/torsoScaled4.cfd04d49.jpg";